import React from "react";
import { useTranslation } from "react-i18next";
import "./Entrevista.css";

export default function Entrevista() {
  const { t } = useTranslation();
  return <h1 className="page-title">{t("pages.entrevista.title")}</h1>;
}

